import './userInfo.scss';

import React from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import ClientAccounts from './clientAccounts';
import ClientInfo from './clientInfo';
import UserSpecificInfo from './userSpecificInfo';
import ContactPerson from './contactPerson';
import TabLink from '../search/tabLink';
import FormMenuControl from '../common/formMenuControl'

import IconClientAccounts from '../../img/icons/BBiconsKlientstkeUcty';
import IconUserSpecificInfo from '../../img/icons/BBiconsInformaceOKlientovi';
import IconClientInfo from '../../img/icons/BBiconsGrZakladniUdajeSpolecnosti';
import IconContactPerson from '../../img/icons/BBiconsKontaktniOsoba';

class UserInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: "clientAccounts"
        };
    }

    changeType = (selected) => this.setState({ selected: selected });

    render() {
        return (
            <div className='content-root content-root-wide user-info'>
                <div className="columns is-desktop">
                    <div className="column is-4-desktop tabs tabs-form-menu" style={{ fontSize: "1em" }}>
                        <FormMenuControl>
                            <ul>
                                <TabLink type='clientAccounts' selected={this.state.selected} onSelect={this.changeType} icon={<IconClientAccounts className="tabs-icon" />}
                                    titleKey='User.ClientAccounts' descriptionKey='User.ClientAccounts.Description' hr={true} />
                                <TabLink type='userSpecificInfo' selected={this.state.selected} onSelect={this.changeType} icon={<IconUserSpecificInfo className="tabs-icon" />}
                                    titleKey='User.UserInfo' descriptionKey='User.UserInfo.Description' hr={true} />
                                <TabLink type='clientInfo' selected={this.state.selected} onSelect={this.changeType} icon={<IconClientInfo className="tabs-icon" />}
                                    titleKey='User.ClientInfo' descriptionKey='User.ClientInfo.Description' hr={true} />
                                <TabLink type='contactPerson' selected={this.state.selected} onSelect={this.changeType} icon={<IconContactPerson className="tabs-icon" />}
                                    titleKey='User.ClientInfo.ContactPerson' descriptionKey='User.ClientInfo.ContactPerson.Description' hr={false} />
                            </ul>
                        </FormMenuControl>
                    </div>
                    <div className='column'>
                        {this.state.selected === "clientAccounts" && <ClientAccounts />}
                        {this.state.selected === "userSpecificInfo" && <UserSpecificInfo />}
                        {this.state.selected === "clientInfo" && <ClientInfo />}
                        {this.state.selected === "contactPerson" && <ContactPerson />}
                    </div>
                </div>
            </div>)
    }
}

export default withLocalize(UserInfo);